import { setIsPresenceLicenseEnabledMutator } from '../mutators/setIsPresenceLicenseEnabledMutator';
import { lazyFetchAssignedPlans, type OrganizationAssignedPlan } from 'owa-presence-service';
import { presenceStore } from '../store/presenceStore';
import type { MailboxInfo } from 'owa-client-types';

export function isPresenceLicenseEnabled(mailboxInfo: MailboxInfo): boolean {
    const isEnabled = presenceStore().isLicenseEnabled;
    if (isEnabled === undefined) {
        lazyFetchAssignedPlans
            .importAndExecute(mailboxInfo)
            .then((plans: OrganizationAssignedPlan[]) => {
                const hasLicense = checkTeamsOrMCO(plans);
                setIsPresenceLicenseEnabledMutator(hasLicense);
            })
            .catch(() => {
                setIsPresenceLicenseEnabledMutator(false);
            });
    }
    return !!isEnabled;
}

function checkTeamsOrMCO(plans: OrganizationAssignedPlan[]): boolean {
    return plans.some(plan => {
        return (
            (plan.service === 'TeamspaceAPI' || plan.service === 'MicrosoftCommunicationsOnline') &&
            plan.capabilityStatus === 'Enabled'
        );
    });
}
